import { Injectable } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { MatSnackBar } from '@angular/material/snack-bar';

@Injectable({
  providedIn: 'root',
})
export class NotificationService {
  constructor(private _toastr: ToastrService, private _snackBar: MatSnackBar) {}

  error(title: string, message: string): void {
    this._toastr.error(message, title,{ progressBar: true });
    // this.openSnackBar(message, title);
  }

  info(title: string, message: string): void {
    this._toastr.info(message, title, { progressBar: true });
    //this.openSnackBar(message, title);
  }

  warning(title: string, message: string): void {
    this._toastr.warning(message, title, { progressBar: true });
    // this.openSnackBar(message, title);
  }

  openSnackBar(message: string, title: string) {
    this._snackBar.open(message, title, {
      duration: 5000,
      horizontalPosition: 'center',
      verticalPosition: 'top',
    });
  }
}
